var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import EventContext from '../context/event-context';
import StateContext from '../context/state-context';
var StyledMenu = styled(MenuList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return ({ ...props.componentStyle }); });
var StyledMenuItem = styled(MenuItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  background-color: ", ";\n"], ["\n  ", "\n  color: ",
    ";\n  background-color: ",
    ";\n"])), function (props) { return ({ ...props.componentStyle }); }, function (_a) {
    var fontColor = _a.fontColor;
    return fontColor ? fontColor + " !important" : 'inherit';
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor ? backgroundColor + " !important" : 'inherit';
});
export function MenuButtons(props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, componentStyle = props.componentStyle, rest = __rest(props, ["options", "componentStyle"]);
    console.log('menu', { props: props });
    return (React.createElement(StyledMenu, __assign({}, rest, { style: componentStyle }), options.map(function (item, index) { return (React.createElement(Item, { item: item, key: index })); })));
}
function Item(_a) {
    var _b;
    var item = _a.item;
    var _onButtonClick = useContext(EventContext)._onButtonClick;
    var id = item.value;
    console.log('menu', { item: item });
    var state = useContext(StateContext);
    var onButtonClick = function (evt) {
        _onButtonClick(id);
    };
    var labelFromState = state[id + "_label"];
    console.log(state, id, state[id + "_fontColor"], state[id + "_backgroundColor"]);
    return (React.createElement(StyledMenuItem, { onClick: onButtonClick, fontColor: state[id + "_fontColor"], backgroundColor: state[id + "_backgroundColor"], style: (_b = item.style) !== null && _b !== void 0 ? _b : {}, id: id }, labelFromState !== null && labelFromState !== void 0 ? labelFromState : item.label));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=MenuButtons.js.map